var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/ProgressBar/ProgressBar.js";
/* eslint-disable no-extra-parens */
import React from "react";
import PropTypes from "prop-types";
var ProgressBar = function ProgressBar(_ref) {
  var progress = _ref.progress;
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "survey-ProgressBar",
    "aria-live": "polite",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("progress", {
    "data-testid": "SurveyProgress",
    max: progress.total_pages,
    value: progress.current_page,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 7
    }
  })));
};

/* eslint-disable camelcase */
ProgressBar.propTypes = {
  progress: PropTypes.shape({
    total_pages: PropTypes.number,
    current_page: PropTypes.number
  }).isRequired
};
/* eslint-enable camelcase */

export { ProgressBar as default };